import { Component, OnInit } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { Utente } from 'src/app/models/rbac/Utente';
import { UtenteService } from 'src/app/services/utente.service';
import { NuovoAccountComponent } from './nuovo-account/nuovo-account.component';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent implements OnInit {
  modalRef: MdbModalRef<NuovoAccountComponent> | null = null;
  accounts: any = []
  utente!: Utente
  
  utenti = []

  constructor(private servUtente: UtenteService,
    private modalService: MdbModalService) {
    servUtente.isLogin.subscribe(utente => {
      this.utente = utente
    })
   }

  ngOnInit(): void {
  }

  aggiungiAccount(){
    this.modalRef = this.modalService.open(NuovoAccountComponent, {
      modalClass: 'modal-lg',
      data: { titolo: 'Nuovo Account' }
    })
    this.modalRef.onClose.subscribe((account: any) => {
      console.log(account);
      /* let dati = {
        nome: utente.getNome(),
        cognome: utente.getCognome(),
        email: utente.getEmail(),
        ruolo: utente.getIDTipoUt(),
        abilitato: utente.getConfirmed() ? '1' : '0'
      }
      this.servUtente.creaUtente(dati).subscribe((data: any) => {
        console.log(data)
      }) */
    });
  }

  modificaAccount(id: number){
    console.log(id)
    this.modalRef = this.modalService.open(NuovoAccountComponent, {
      modalClass: 'modal-lg',
      data: {
        titolo: 'Modifica Utente',
        utente: this.accounts.find((u:any) => u.getID() == id)
      }
    })
    this.modalRef.onClose.subscribe((utente: Utente) => {
      console.log(utente);
      let dati = {
        id: utente.getID(),
        nome: utente.getNome(),
        cognome: utente.getCognome(),
        email: utente.getEmail(),
        ruolo: utente.getIDTipoUt(),
        abilitato: utente.getConfirmed() ? '1' : '0'
      }
      this.servUtente.modificaUtente(dati).subscribe((data: any) => {
        console.log(data)
      })
    });
  }

}
